
import Component from 'vue-class-component'
import Vue from 'vue'
import api from '@/api'

@Component
export default class PortalLayoutView extends Vue {}
